export default __webpack_public_path__ + "1ab45e9a3dd360cdbbe998626aaa5ca1.svg";